<template>  
        <div class="mt-1 p-2 pt-3">
                      <span class="font-14 ml-2    color-secondary-6">
                         Informes Enmendados
                         </span>                         
                        <div class="bg-white mt-3 rounded p-2" v-for="(item, index) in items" :key="index">
                            <div class="row mx-0 padding-amendlist">
                                <div class="col-md-2 border-right custom-version-title-container">
                                    <p class="data-content mt-4 version-title-mobile  text-center font-weight-bold">Versión {{item.fileRevision}}</p>
                                </div>
                                <div class="col-md-2">
                                    <label class="data-label mt-2 mb-0">Tipo de Archivo:</label>
                                    <p class="data-content mt-0">{{item.fileSpecification.name}}</p>
                                </div>
                                <div class="col-md-2">
                                    <label class="data-label  mt-2 mb-0">Fecha:</label>
                                    <p class="data-content  mt-0">{{item.date | date}}</p>
                                </div>
                                <div class="col-md-2">                                    
                                  <template v-if="item.amendReason">
                                    <label class="data-label mt-2 mb-0">Razón de Enmienda:</label>
                                    <p class="data-content mt-0">{{ item.amendReason }}</p>                                    
                                  </template>
                                </div>
                                <div class="col-md-4">
                                    <p class="text-right">   
                                        <action-button
                                            variant="outline-success mt-3 mr-3 btn-block-xs-only "
                                            i="fa fa-print font-18"
                                            class-icon="mx-0 no-margin"
                                            @click="$emit('on-download', item.id)"
                                            />
                                    </p>
                              </div>
                            </div>
                        </div>
                    </div>
</template>

<script>
import ActionButton from "ActionButton";

export default {
  name: "AmendedReportRow",
  components: {
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped>
.padding-amendlist
{
  padding-left: 2rem !important;
}
</style>
